<template>
  <v-container fluid grid-list-md text-center :class="sysForegroundColor">
    <v-layout row wrap>
      <v-flex>
        <v-img
          :src="require('../assets/logo.png')"
          contain
          height="100"
        ></v-img>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex v-if="sysNombre == ''">
        <v-progress-circular
          indeterminate
          color="blue"
          :size="30"
          :width="5"
        ></v-progress-circular>
      </v-flex>
      <v-flex v-else>
        <span class="headline font-weight-light">{{ sysNombre }}</span>
        <p class="caption font-weight-light">
          {{ sysDireccionLocalidad }}
          <br />
          {{ sysTelefonoEmail }}
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    sysNombre() {
      return this.$store.state.sysNombre;
    },
    sysDireccionLocalidad() {
      return this.$store.state.sysDireccionLocalidad;
    },
    sysTelefonoEmail() {
      return this.$store.state.sysTelefonoEmail;
    },
    sysForegroundColor() {
      return this.$store.state.sysForegroundColor;
    }
  }
};
</script>
